const TERMINAL_STATUSES = new Set([
  "completed", "cancelled", "canceled", "no show", "rescheduled", "expired", "deleted",
]);

export const isTerminalAppointment = (status) => TERMINAL_STATUSES.has(
  String(status || "").trim().toLowerCase().replaceAll("_", " ").replace(/\s+/g, " "),
);
